import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocTypesAndCategoryAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const documentCategory = control.get('documentCategory')!.value;
	const foreignCustomerId = control.get('foreignCustomerId')!.value;
	const documentTypeArray = ['EGD020', 'EGD022', 'EGD028', 'EGD032'];

	return !foreignCustomerId && documentCategory !== 'EGD02'  && documentTypeArray.includes(documentType) ?
		{ checkDocTypesAndCategoryAllowedFlag: true } : null;

};
